import { useQuery } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';
import helpers from 'apis/core/helpers';

async function getServiceTemplate({ organisationId, serviceTemplateId }) {
  try {
    if (!organisationId) throw new Error('Organisation ID is required');
    if (!serviceTemplateId) throw new Error('Service template ID is required');

    const response = await axiosPrivate.get(
      `/v3/pharmacist/organisations/${organisationId}/service-templates/${serviceTemplateId}`
    );

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  } catch (error) {
    if (error?.response?.data?.error?.text) throw new Error(error.response.data.error.text);
    throw error;
  }
}

export const getServiceTemplateQueryKey = (organisationId, serviceTemplateId) => [
  'organisations',
  organisationId,
  'service-templates',
  serviceTemplateId,
];

export default function useGetServiceTemplate({
  organisationId,
  serviceTemplateId,
  silenceErrors = false,
}) {
  return useQuery({
    queryKey: getServiceTemplateQueryKey(organisationId, serviceTemplateId),
    queryFn: () => getServiceTemplate({ organisationId, serviceTemplateId }),
    enabled:
      Boolean(organisationId) &&
      Boolean(serviceTemplateId) &&
      serviceTemplateId !== 'new-service-template',
    meta: { errorMessage: 'Failed to load service template', silenceErrors },
    ...(silenceErrors && { retry: false }),
  });
}
